module.exports = __webpack_public_path__ + "static/banner-guillaume-desktop-fb746864d06fe636bf72f9a720b7a8b8.jpg";